define('models/Podio.Models.Space',['require','lib/backbone/Backbone.PodioModel','lib/Podio.Routes','lib/Podio.Utils','models/Podio.Models.Organization'],function(require) {

  var PodioModel = require('lib/backbone/Backbone.PodioModel');
  var routes = require('lib/Podio.Routes');
  var podioUtils = require('lib/Podio.Utils');

  return PodioModel.extend({
    urlRails: function() {
      // HACK: Currently only used by default space tour for updating a space
      return routes.update_space_with_current_space_path();
    },

    urlAPI: function() {
      return '/space/{0}'.format(this.get('id'));
    },

    has_one: function() {
      return {
        'org': require('models/Podio.Models.Organization')
      };
    },

    fetchFromAPIBySpaceAndOrgSlugs: function() {
      // @see https://developers.podio.com/doc/spaces/get-space-by-org-and-url-label-476929
      return this.fetch({
        url: '/space/url',
        data: { org_slug: this.get('org').get('url_label'), space_slug: this.get('url_label') }
      });
    },

    isEmployeeNetwork: function() {
      return this.get('type') === 'emp_network';
    }

  });

});

